/** 统一渲染表单必填标识，供未使用 Form.Item 的迁移表单复用。 */
export default function RequiredMark() {
    return (
        <span aria-hidden="true" className="admin-required-mark">
            *
        </span>
    );
}
